<template>
	<div class="quick-link-container">
        <!-- 快捷功能 -->
        <div class="quick-link-grid">
            <div 
                class="link-item" 
                v-for="item in linkItems" 
                :key="item.id"
                @click="handleLinkClick(item)"
            >
                <div class="link-icon">
                    <van-image
                        width="48"
                        height="48"
                        :src="item.icon"
                        fit="contain"
                    />
                </div>
                <div class="link-text">{{ item.text }}</div>
            </div>
        </div>
	</div>	
</template>

<script>
	import global  from './global.vue'; 
	export default {
	 name: 'quickLink',     
	 data(){		
		return{	
			Driver: require("@/assets/icon/Driver.png"),				
			feedback: require("@/assets/icon/Unknow.png"),
			svcproduct: require("@/assets/icon/inwpolicy.png"),
			sns : '',
			linkItems: [
				{ id: 1, icon: require("@/assets/icon/Unknow.png"), text: '手册指南', action: 'gotoManual' },
				{ id: 2, icon: require("@/assets/icon/video.png"), text: '安装视频', action: 'gotoVideo' },
				{ id: 3, icon: require("@/assets/icon/Driver.png"), text: '驱动下载', action: 'toDriver' },
				{ id: 4, icon: require("@/assets/icon/feedback.png"), text: '意见反馈', action: 'toFeedback' }
			]		
		}
	 },
	 created(){
		this.sns = this.$route.query.sn
	 },
	 methods:{	
		handleLinkClick(item) {
			global.applog(item.text);
			this[item.action]();
		},
		
		gotoVideo(){
			this.$router.push({ path:'/productinfo/showVideo?sn=' +  this.sns })
		},
		gotoManual(){
			this.$router.push({ path:'/productinfo/showArticle?sn=' +  this.sns })	
		},				
		toFeedback(){
			this.$router.push({ path:'/feedback'  })
		}, 
		toDriver(){
			this.$router.push({ path:'/drivers?sn=' + this.sns })				
		}
	  }
  }
</script>

<style scoped>
.quick-link-container {
    padding: 12px 8px;
    background: transparent;
    box-sizing: border-box;
    width: 100%;
    overflow: hidden;
}

.quick-link-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 8px;
    max-width: 100%;
    margin: 0 auto;
    box-sizing: border-box;
}

.link-item {
    background: #ffffff;
    border-radius: 12px;
    padding: 8px 4px;
    text-align: center;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
    border: 1px solid #f0f0f0;
    transition: all 0.3s ease;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    /* 保持方形比例 */
    aspect-ratio: 1 / 1;
    min-height: 0;
}

.link-item:active {
    background: #f7f8fa;
    transform: scale(0.95);
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);
}

.link-icon {
    margin-bottom: 8px;
    width: 48px;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    padding: 6px;
    box-sizing: border-box;
}

.link-text {
    font-size: 12px;
    font-weight: 500;
    color: #323233;
    line-height: 1.4;
    word-break: break-all;
}

/* 为不同功能项添加不同的图标背景色 */
.link-item:nth-child(1) .link-icon {
    background: linear-gradient(135deg, #e6f7ff, #bae7ff);
}

.link-item:nth-child(2) .link-icon {
    background: linear-gradient(135deg, #f6ffed, #d9f7be);
}

.link-item:nth-child(3) .link-icon {
    background: linear-gradient(135deg, #fff7e6, #ffe7ba);
}

.link-item:nth-child(4) .link-icon {
    background: linear-gradient(135deg, #fff2f0, #ffccc7);
}

/* 小屏幕优化 */
@media (max-width: 390px) {
    .quick-link-container {
        padding: 8px 6px;
    }
    
    .quick-link-grid {
        gap: 6px;
    }
    
    .link-item {
        padding: 6px 3px;
        border-radius: 10px;
    }
    
    .link-icon {
        margin-bottom: 6px;
        padding: 5px;
    }
}

@media (max-width: 360px) {
    .quick-link-container {
        padding: 6px 4px;
    }
    
    .quick-link-grid {
        gap: 4px;
    }
    
    .link-item {
        padding: 5px 2px;
        border-radius: 8px;
    }
    
    .link-icon {
        margin-bottom: 4px;
        padding: 4px;
    }
}

/* 超小屏幕改为2列布局 */
@media (max-width: 320px) {
    .quick-link-grid {
        grid-template-columns: repeat(2, 1fr);
        gap: 8px;
    }
    
    .quick-link-container {
        padding: 8px 6px;
    }
    
    .link-item {
        aspect-ratio: 1 / 1;
        padding: 8px 4px;
    }
}

/* 悬停效果（桌面端） */
@media (hover: hover) {
    .link-item:hover {
        background: #f7f8fa;
        transform: translateY(-1px);
        box-shadow: 0 3px 8px rgba(0, 0, 0, 0.1);
    }
}
</style>